<template>
  <div class="tab-content">
    <div class="mb-4">
      <h2 class="mb-2">Описание</h2>
      <va-input
        v-model="descriptionModel"
        type="textarea"
        class="mb-0"
        :min-rows="2"
        :max-rows="4"
      />
    </div>
    <div class="mb-4">
      <h2 class="mb-2">Размеры</h2>
      <div class="d-flex gap-3">
        <div style="flex: 1">
          <va-input
            v-model.number="formData.size_width"
            type="number"
            placeholder="Ширина"
            class="mb-0"
            min="0"
            step="0.01"
          />
        </div>
        <div style="flex: 1">
          <va-input
            v-model.number="formData.size_height"
            type="number"
            placeholder="Высота"
            class="mb-0"
            min="0"
            step="0.01"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProductFormTabDescription",
  props: {
    formData: { type: Object, required: true },
    validation: { type: Object, default: null },
    errors: { type: Object, default: () => ({}) },
  },
  computed: {
    descriptionModel: {
      get() {
        return this.validation?.formData?.description?.$model ?? this.formData.description;
      },
      set(v) {
        if (this.validation?.formData?.description?.$model !== undefined) {
          this.validation.formData.description.$model = v;
        } else {
          this.formData.description = v;
        }
      },
    },
  },
};
</script>

<style scoped>
.tab-content {
  grid-column: 1 / -1;
}
.error-message {
  color: #ff4444;
  font-size: 0.875rem;
  margin-top: 4px;
}
</style>
